import { Key } from "lucide-react";
import { MetricWidget } from "@/components/custom/widgets/metric-widget";
import { useGetSecrets } from "../../../secrets/api/hooks";

export function SecretsMetric() {
  const { data: secretsCount = 0 } = useGetSecrets<number>("project", {
    select: (secrets) => (Array.isArray(secrets) ? secrets.length : 0),
  });

  return (
    <MetricWidget
      href="/orgs/$organizationId/projects/$projectId/auth/secrets"
      icon={Key}
      title="Secrets"
      value={secretsCount}
    />
  );
}
